export default {
  users: "Users",
  addUsers: "AddUsers",
  editUsers: "EditUsers",
};
